/* 🤖 this file was generated by svg-to-ts */
export const iccIconCommentQuote: {
  name: 'comment_quote';
  data: string;
} = {
  name: 'comment_quote',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)" fill="currentColor"><path d="M20 17.17 18.83 16H4V4h16v13.17ZM20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2Z"/><path d="M15.31 13h-2.62l1-2H12.5V7h4v3.62L15.31 13Zm-1-1h.38l.81-1.62V8h-2v2h1.81l-1 2Zm-4 1H7.69l1-2H7.5V7h4v3.62L10.31 13Zm-1-1h.38l.81-1.62V8h-2v2h1.81l-1 2Z"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h24v24H0z"/></clipPath></defs></svg>`
};
